//src/app/features/questionnaires/create/PrepareQuestionnaire/useFields.ts
import { useContext } from 'react';
import { CreateQuestionnaireContext } from '../index';
import { useSelector } from 'react-redux';
import { selectPrepareQuestionnaire, TaxRequestType } from './slice';
import { commonFields, commonFieldsValidationSchema } from './fields';
import {
  businessFields,
  validationSchema as businessValidationSchema,
} from './fields/businessFields';
import {
  individualFields,
  validationSchema as individualValidationSchema,
} from './fields/individualFields';

export function getIndividualOrBusinessFields(
  serviceType: TaxRequestType | null,
  isSubscribed: boolean,
) {
  if (isSubscribed) {
    return {
      fields: [commonFields.find((f) => f.name === 'year')!],
      validationSchema: commonFieldsValidationSchema,
    };
  }
  switch (serviceType) {
    case TaxRequestType.Business:
      return {
        fields: businessFields,
        validationSchema: businessValidationSchema,
      };
    case TaxRequestType.Individual:
      return {
        fields: individualFields,
        validationSchema: individualValidationSchema,
      };
    default:
      return {
        fields: commonFields,
        validationSchema: commonFieldsValidationSchema,
      };
  }
}

export function useFields() {
  const taxRequestTarget = useSelector(selectPrepareQuestionnaire);

  // admin‐only: gives you clientBusinesses + clientId
  const { clientBusinesses, clientId } = useContext(CreateQuestionnaireContext);

  // pick the right list
  const businesses = clientId ? clientBusinesses || [] : []; // or fall back to useGetUserBusinessesQuery().data

  // find whatever business the user chose in the wizard
  const selectedBusiness = businesses.find(
    (b) => b.id.toString() === taxRequestTarget.businessId?.toString(),
  );

  // coerce string/"true" or boolean true into a real boolean
  const rawTaxFlag = (selectedBusiness as any)?.subscribed?.TAX;
  const isSubscribed = rawTaxFlag === true || rawTaxFlag === 'true';

  const serviceType = taxRequestTarget.taxRequestType;
  const { fields, validationSchema } = getIndividualOrBusinessFields(
    serviceType,
    isSubscribed,
  );

  const subscriptionLabel = isSubscribed
    ? 'Your business is already subscribed with us, we have minimized the questions for you.'
    : null;

  return { fields, validationSchema, subscriptionLabel, isSubscribed };
}
